import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { tapResponse } from '@ngrx/operators';
import { Observable, switchMap } from 'rxjs';
import {
  IKanbanViewComponentState,
  IRankTransition,
} from '../../../../../shared/components/kanban-view/kanban-view.store';
import { ELoadStatus } from '../../../../../state/state.interface';
import { IBaseResponse } from '../../../../../utilities/http-utilities.service';

export interface IKamishibaiCardComponentState {
  dataLoading: ELoadStatus;
}

@Injectable()
export class IKamishibaiCardStore extends ComponentStore<IKamishibaiCardComponentState> {
  public readonly dataStatus$ = this.select((state: IKanbanViewComponentState) => state.dataLoading);

  public readonly changeItemStatusColor = this.effect((trigger$: Observable<IRankTransition>) =>
    trigger$.pipe(
      switchMap((item: IRankTransition) => {
        this.patchState({ dataLoading: ELoadStatus.loading });

        return this.updateItem(item).pipe(
          tapResponse(
            () => this.patchState({ dataLoading: ELoadStatus.success }),
            () => {
              this.patchState({ dataLoading: ELoadStatus.failure });
            },
          ),
        );
      }),
    ),
  );

  constructor(private readonly http: HttpClient) {
    super({
      dataLoading: ELoadStatus.initial,
    });
  }

  private updateItem(assignment: IRankTransition): Observable<IBaseResponse<void>> {
    return this.http.patch<IBaseResponse<void>>('items/change-rank', assignment);
  }
}
